import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconNoAccessColor from './icon-no-access-color.vue';

const IconNoAccessColor = Object.assign(_IconNoAccessColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconNoAccessColor.name, _IconNoAccessColor);
  }
});

export default IconNoAccessColor;
